import { createClient } from "@supabase/supabase-js";

/**
 * Shiveda IT Services - Centralized Supabase Client
 *
 * Uses ONLY browser-safe publishable keys (REACT_APP_SUPABASE_PUBLISHABLE_KEY).
 * Never import or expose secret or service_role keys in frontend code.
 */

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://gmebbsabvihoxgcogjbs.supabase.co";
const supabasePublishableKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "";

if (!supabasePublishableKey && process.env.NODE_ENV !== "production") {
  console.warn(
    "[Supabase] Warning: REACT_APP_SUPABASE_PUBLISHABLE_KEY is not defined in environment variables. Falling back to default configuration."
  );
}

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "shiveda_supabase_auth_token",
  },
  global: {
    headers: {
      "x-application-name": "shiveda-portfolio",
    },
  },
});

export default supabase;
